import * as React from "react";
import "../../style/fonts.css";
import "./login.css";
import { signIn, resetAuthError } from "src/store/actions/authActions";
import Input from "../input/input";
import hidden_pass from "../../icons/hidden.svg";
import visible_pass from "../../icons/visible.svg";
import CtaButton from "../ctaButton/ctaButton";
import { connect } from "react-redux";
import { Link, Redirect, withRouter } from "react-router-dom";
import { matchPath } from "react-router";

import {
  followUserAfter,
  redirectAfterLogin,
  resetRedirectVars,
  checkFollowList,
  resetFollowList,
} from "../../store/actions/supportActions";
import translate from "../../translations/i18n";
import { getFirebase } from "react-redux-firebase";

export interface Props {
  signIn(credentials): void;
  authError: string;
  ownAuth: any;
  userStatusToFollow: any;
  userToFollowWithoutLogIn: any;
  userIdToFollowWithoutLogIn: any;
  followUserAfter(uid, user): void;
  redirectAfterLogin(): void;
  redirectUserAfterLogIn: any;
  redirectUserAfterFollow: any;
  resetRedirectVars(): void;
  resetAuthError: () => void;
  alreadyFollowingChecked: any;
  alreadyFollowing: any;
  checkFollowList: (uid, followID) => void;
  resetFollowList: () => void;
  history: any;
}

interface State {
  email: string;
  password: string;
  seePassword: boolean;
}

class LoginScr extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      email: "",
      password: "",
      seePassword: false,
    };
    this.login = this.login.bind(this);
  }

  componentDidMount() {
    this.props.resetAuthError();
    this.props.resetFollowList();
    if (this.props.userStatusToFollow === true) {
      this.props.redirectAfterLogin();
    }
  }

  passSeen() {
    this.setState((prevState) => ({
      seePassword: !prevState.seePassword,
    }));
  }

  showEye() {
    if (this.state.seePassword) return <img src={hidden_pass} />;
    else return <img src={visible_pass} />;
  }

  handleChangeMail(event) {
    this.setState({ email: event.target.value });
  }

  handleChangePass(event) {
    this.setState({ password: event.target.value });
  }

  login() {
    this.props.signIn(this.state);
  }

  componentWillUnmount() {
    if (this.props.alreadyFollowing === false) {
      this.props.followUserAfter(
        this.props.ownAuth.uid,
        this.props.userToFollowWithoutLogIn
      );
    }
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.ownAuth.isEmpty === false &&
      this.props.userStatusToFollow === true
    ) {
      this.props.checkFollowList(
        this.props.ownAuth.uid,
        this.props.userToFollowWithoutLogIn.uid
      );
    }
  }

  render() {
    const match = matchPath(this.props.history.location.pathname, {
      path: "/login/:downloadUserData",
      exact: true,
      strict: false,
    });

    const downloadUserDataScreen = match && match.params.downloadUserData;

    if (
      this.props.redirectUserAfterLogIn === true &&
      this.props.alreadyFollowingChecked === true
    ) {
      const userId = this.props.userIdToFollowWithoutLogIn;
      this.props.resetRedirectVars();
      return <Redirect to={`/profile/${userId}`} push />;
    } else if (
      (this.props.redirectUserAfterLogIn === null &&
        !(this.props.ownAuth.isEmpty === true)) ||
      this.props.ownAuth.uid
    ) {
      if(downloadUserDataScreen) {
        return <Redirect to={"/downloadUserData"} push />;

      } else {
        return <Redirect to={"/overview"} push />;
      }
    }

    return (
      <div className="LOGIN_CONT">
        <div className="EMAIL_INPUT_CONT">
          <Input
            type={"text"}
            placeholder={translate("EMAIL_FORM")}
            value={this.state.email}
            onChange={this.handleChangeMail.bind(this)}
            // warning={null}
            warning={this.props.authError && translate(this.props.authError)}
            passwordSeen={null}
          />
        </div>
        <div className="PASSWORD_INPUT_CONT">
          <Input
            type={"password"}
            placeholder={translate("PASSWORD_FORM")}
            value={this.state.password}
            onChange={this.handleChangePass.bind(this)}
            // warning={null}
            warning={this.props.authError && translate(this.props.authError)}
            passwordSeen={this.state.seePassword}
          />
          <div className="PASS_ICON" onClick={this.passSeen.bind(this)}>
            {this.showEye()}
          </div>
        </div>
        <div className="LOGIN_BTN_AREA">
          <div onClick={this.login.bind(this)}>
            <CtaButton
              width={"280px"}
              text={translate("CTA_LOGIN")}
              color={"white"}
            />
          </div>
        </div>
        <Link to="./retPass">
          <div className="FORGOT_PASS_CONT">
            <div className="TITLE_3">{translate("CTA_FORGOT_PASSWORD")}</div>
          </div>
        </Link>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    authError: state.auth.authError,
    userStatusToFollow: state.sup.userStatustoFollow,
    userIdToFollowWithoutLogIn: state.sup.userIdToFollowWithoutLogIn,
    userToFollowWithoutLogIn: state.sup.userToFollowWithoutLogIn,
    alreadyFollowingChecked: state.sup.alreadyFollowingChecked,
    alreadyFollowing: state.sup.alreadyFollowing,
    ownAuth: state.firebase.auth,
    redirectUserAfterLogIn: state.sup.redirectUserAfterLogIn,
    redirectUserAfterFollow: state.sup.redirectUserAfterFollow,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    signIn: (creds) => dispatch(signIn(creds)),
    followUserAfter: (uid, user) => dispatch(followUserAfter(uid, user)),
    redirectAfterLogin: () => dispatch(redirectAfterLogin()),
    resetRedirectVars: () => dispatch(resetRedirectVars()),
    resetAuthError: () => dispatch(resetAuthError()),
    checkFollowList: (uid, followId) =>
      dispatch(checkFollowList(uid, followId)),
    resetFollowList: () => dispatch(resetFollowList()),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(LoginScr)
);



// WEBPACK FOOTER //
// ./src/components/Registration/login.tsx